import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../utils/axiosAuth";

// Fetch all loyalty programs
export const fetchLoyaltyPrograms = createAsyncThunk(
  "cardsCoupons/fetchLoyaltyPrograms",
  async (_, thunkAPI) => {
    try {
      const response = await api.get("/api/loyalty-programs");
      console.log("loyaltyPrograms", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch error");
    }
  }
);

// Fetch used cards by loyalty program
export const fetchUsedCardsByLoyaltyProgram = createAsyncThunk(
  "cardsCoupons/fetchUsedCardsByLoyaltyProgram",
  async (params, thunkAPI) => {
    const { loyalty_program_id, fromdate, todate } = params;
    try {
      const response = await api.post("/api/used-cards-by-loyalty-program", {
        loyalty_program_id,
        fromdate,
        todate,
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch error");
    }
  }
);

const cardsCouponsSlice = createSlice({
  name: "cardsCoupons",
  initialState: {
    loyaltyPrograms: [],
    usedCards: [],
    status: "idle",
    error: null,
  },
  reducers: {
    clearUsedCards: (state) => {
      state.usedCards = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch loyalty programs
      .addCase(fetchLoyaltyPrograms.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchLoyaltyPrograms.fulfilled, (state, action) => {
        state.loyaltyPrograms = action.payload;
        state.status = "succeeded";
      })
      .addCase(fetchLoyaltyPrograms.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Fetch used cards
      .addCase(fetchUsedCardsByLoyaltyProgram.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUsedCardsByLoyaltyProgram.fulfilled, (state, action) => {
        state.usedCards = action.payload;
        state.status = "succeeded";
      })
      .addCase(fetchUsedCardsByLoyaltyProgram.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearUsedCards } = cardsCouponsSlice.actions;

// Selectors
export const selectLoyaltyPrograms = (state) =>
  state.cardsCoupons.loyaltyPrograms;
export const selectUsedCards = (state) => state.cardsCoupons.usedCards;
export const selectCardsCouponsStatus = (state) => state.cardsCoupons.status;
export const selectCardsCouponsError = (state) => state.cardsCoupons.error;

export default cardsCouponsSlice.reducer;
